import { adminActionTypes } from "src/action_types/section_action_types";

export function selectRiskAlertRulesTablePageNumberAction(pageNumber) {
  return {
    type: adminActionTypes.selectRiskAlertRulesTablePageNumber,
    payload: pageNumber
  };
}
